<template>
  <document-edit :formList="formList" @handleSave="handleSave" @onFieldClick="onFieldClick">
    <div slot="header">page-header 头部信息</div>
    <template slot="fieldCom" slot-scope="{ field }">
      <base-switch
        v-if="field.fieldType === 'boolean'"
        :title="field.name"
        v-model="field.value"
        :valueMap="{ true: 'true', false: 'false' }"
        :disable="!field.editable"
        :required="field.required"
      />
      <tip-text-area v-else-if="field.fieldType === 'tipTextArea'" :text="field.placeholder" />
    </template>
  </document-edit>
</template>

<script>
import DocumentEdit from 'components/business/common/document-edit';
import baseSwitch from 'components/base-ui/base-switch';
import tipTextArea from '@/components/business/custom-form/tip-text-area/index.vue';
import { getDocumentField } from 'components/business/common/document-edit/service.index';
export default {
  name: 'test',
  data() {
    return {
      formList: [
        getDocumentField({ fieldType: 'boolean', name: 'test boolean', value: false }),
        getDocumentField({ fieldType: 'tipTextArea', placeholder: 'test tipTextArea' }),
        getDocumentField({ fieldType: 'baseSelect', name: 'test baseSelect-1', required: true }),
        getDocumentField({ fieldType: 'baseSelect', name: 'test baseSelect-2' }),
        getDocumentField({ fieldType: 'input', name: 'test input', required: true }),
      ],
    };
  },
  methods: {
    onFieldClick(field) {
      // console.log('onFieldClick', field);
      let value = new Date().getTime();
      field.value = value;
      field.showValue = value;
    },
    handleSave() {
      // console.log('handleSave', this.formList);
    },
  },
  components: {
    DocumentEdit,
    baseSwitch,
    tipTextArea,
  },
};
</script>

<style scoped></style>
